import { Component, forwardRef, Inject, OnDestroy, OnInit } from '@angular/core';
import { ISearch } from '../../interfaces/search';
import { CustomerService } from '../../services/customer.service';
import { DisputeService } from '../../services/dispute.service';
import { EnvironmentService } from '../../services/environment.service';
import { OrderService } from '../../services/order.service';
import { UserService } from '../../services/user.service';
import { AppComponent } from './app.component';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BBWTMessageService } from '../../services/message.service';
import { IncidentsService } from '../../services/incidents.service';
import { EventService } from '../../services/event.service';
import { IBasicOrganisationInfo } from '../../interfaces/telephony/basic-organisation-info';
import { SupplierInfoEventTypeEnum } from '../../interfaces/telephony/supplier-info-event-type.enum';
import { ISupplierInfoEvent } from '../../interfaces/telephony/supplier-info-event';
import { OrganisationSelectorEventTypeEnum } from '../../interfaces/telephony/organisation-selector-event-type.enum';
import { IOrganisationSelectorEvent } from '../../interfaces/telephony/organisation-selector-event';
import { Subscription } from 'rxjs';
import { parse } from 'url';
import { OrganisationTypeEnum } from '../../enums/organisation-types';
import { TelephonyService } from '../../services';

@Component({
  selector: 'app-topbar',
  templateUrl: './app-topbar.component.html',
  styleUrls: ['./app-topbar.component.scss'],
})
export class AppTopBarComponent implements OnInit, OnDestroy {
  public searchModel: ISearch = { value: '', searchType: '' };
  public isVmeUser: boolean = false;
  public isSaasUser: boolean = false;
  public organisationTypeId: number = 0;
  public incidentsTotal: number = 0;
  public myIncidentsTotal: number = 0;
  public activeSubTopbarItem: any;
  public logo: string;
  public isUserImpersonate = false;
  public impersonatedUserName: string = '';
  public isProduction: boolean;
  public isBeta: boolean;
  public showSpinner = false;
  public searchChoices = false;

  public restrictedUser = false;

  public loadingSupplierInfo = false;
  private transactionSearchSubscription: Subscription;

  public currentOrgPromise: Promise<any>;

  public isSuspended = false;

  constructor(
    @Inject(forwardRef(() => AppComponent)) public app: AppComponent,
    private userService: UserService,
    private eventService: EventService,
    private incidentsService: IncidentsService,
    private router: Router,
    private customerService: CustomerService,
    private http: HttpClient,
    private disputeService: DisputeService,
    private orderService: OrderService,
    public messageService: BBWTMessageService,
    private environmentService: EnvironmentService,
  ) {
    this.currentOrgPromise = this.userService.getCurrentUserOrg();
    this.currentOrgPromise.then((org) => {
      this.isVmeUser = org.organisationTypeId == OrganisationTypeEnum.Engineius;
      this.isSaasUser = org.organisationTypeId == OrganisationTypeEnum.SaaSCustomer;
      this.organisationTypeId = org.organisationTypeId;

      this.isSuspended = !!org.suspended;
    });

    this.isProduction = this.environmentService.isProduction();
    this.isBeta = this.environmentService.isBeta();
  }

  async ngOnInit() {
    // check if user is in restricted 'shareholder' role
    // if they are then top-bar wll be empty
    this.restrictedUser = await this.userService.isUserInRole('SHAR');

    if (!this.restrictedUser) {
      this.isUserImpersonating();
    }

    this.currentOrgPromise.then(() => {
      if (!this.restrictedUser && this.isVmeUser) {
        this.incidentsService.startNotificationCountsPolling();
        this.incidentsService.notificationCountsPolling.subscribe((res) => {
          this.incidentsTotal = (res && res.unAssigned) || 0;
          this.myIncidentsTotal = (res && res.assignedToMe) || 0;
        });
      }
    });

    this.eventService.JobSearchEvent.subscribe((input) => {
      if (input.searchComplete) {
        this.showSpinner = false;
      }
    });

    this.eventService.SupplierInfoEvent.subscribe((event: ISupplierInfoEvent) => {
      if (event.eventType == SupplierInfoEventTypeEnum.InfoLoading) {
        this.loadingSupplierInfo = true;
      }
      if (event.eventType == SupplierInfoEventTypeEnum.InfoLoaded) {
        this.loadingSupplierInfo = false;
      }
    });

    this.transactionSearchSubscription = this.eventService.TransactionSearchEvent.subscribe(
      (input) => {
        if (input.searchComplete) this.showSpinner = false;
      },
    );

    this.eventService.OrganisationSelectorEvent.subscribe((event: IOrganisationSelectorEvent) => {
      if (event.eventType == OrganisationSelectorEventTypeEnum.OrganisationSelected) {
        this.showOrganisationInfo(event.args);
      }
    });

    //this.rcService.setupRC();
  }

  openSubMenu(item) {
    this.activeSubTopbarItem = item;
  }

  openIncidents() {
    this.router.navigate(['app/incidents']);
  }

  async logout(event) {
    event.preventDefault();
    await this.userService.logout();
  }

  openProfile(event: Event) {
    event.preventDefault();
    if (this.organisationTypeId != OrganisationTypeEnum.Customer && this.isUserImpersonate) {
      this.router.navigate(['app/supplier-profile']);
    } else {
      this.router.navigate(['app/profile']);
    }
  }

  stopImpersonate(event) {
    this.userService
      .stopImpersonateUser()
      .then((res) => {
        window.location.reload();
        window.location.href = '/';
      })
      .catch((errorResponse: HttpErrorResponse) => {
        console.log(errorResponse.message);
      });
    event.preventDefault();
  }

  isUserImpersonating() {
    this.userService
      .isUserImpersonating()
      .then((res) => {
        var resultData: any;
        resultData = res;
        if (resultData != null) {
          this.isUserImpersonate = resultData.isImpersonating;
          // this.loggedUser = !resultData.isImpersonating ? "User " + resultData.impersonatedUserName :
          //     `User ${resultData.impersonatedUserName} via user ${resultData.originalUserName}`;

          localStorage.setItem('loggedUserName', resultData.impersonatedUserName);
          localStorage.setItem('loggedUserEmail', resultData.impersonatedUserEmail);
          this.impersonatedUserName = resultData.impersonatedUserName;
        } else {
          this.isUserImpersonate = false;
        }
      })
      .catch((errorResponse: HttpErrorResponse) => {
        console.log(errorResponse.message);
      });
  }

  showSearchChoices(event: Event) {
    event.preventDefault();
    this.searchModel.searchType = null;

    // If we can guess what it already is
    const value = this.searchModel.value.toUpperCase();

    const orderPrefixes = ['R-'];
    const jobPrefixes = ['J-', 'JX-'];

    if (orderPrefixes.some((prefix) => value.startsWith(prefix))) {
      this.searchModel.searchType = 'order';
    } else if (jobPrefixes.some((prefix) => value.startsWith(prefix))) {
      this.searchModel.searchType = 'job';
    }

    if (this.searchModel.searchType != null) {
      this.searchJobs(this.searchModel);
    } else {
      this.searchChoices = true;
    }
  }

  searchJobs(data: ISearch) {
    if (data.value == null || data.value.length < 4) {
      this.messageService.ShowError('Search', 'Request length must be more than 4 characters');
      return;
    }

    this.searchChoices = false;
    this.showSpinner = true;

    let emitUpdate: boolean;

    if (parse(this.router.url).pathname.startsWith('/app/jobsearch/')) {
      emitUpdate = true;
    }

    if (data.searchType != 'postcode') {
      data.value = data.value.replace(/ /g, '');
    }

    this.router
      .navigate(['app/jobsearch/' + data.value], { queryParams: { searchType: data.searchType } })
      .then(() => {
        if (emitUpdate == true) {
          this.eventService.JobSearchEvent.emit({ runSearch: true });
        }
      });
  }

  searchTransactions(data: ISearch) {
    if (data.value == null || data.value.length < 4) {
      this.messageService.ShowError('Search', 'Request length must be more than 4 characters');
      return;
    }

    this.searchChoices = false;
    this.showSpinner = true;

    let emitUpdate: boolean;

    if (parse(this.router.url).pathname.startsWith('/app/transactionsearch/')) {
      emitUpdate = true;
    }

    this.router
      .navigate(['app/transactionsearch/' + data.value], {
        queryParams: { searchType: data.searchType },
      })
      .then(() => {
        if (emitUpdate == true) {
          this.eventService.TransactionSearchEvent.emit({ runSearch: true });
        }
      });
  }

  myIncidents(event: Event) {
    event.preventDefault();
    this.router.navigate(['app/incidents/1']);
  }

  showOrganisationInfo(org: IBasicOrganisationInfo) {
    //this.eventService.SupplierInfoEvent.emit({ eventType: SupplierInfoEventTypeEnum.LoadInfoFromId, args: org.id });

    // navigate to stand-alone supplier info page
    if (org.organisationTypeId == OrganisationTypeEnum.Supplier) {
      this.router.navigate([`app/supplier-information/${org.id}`]);
    }
    if (org.organisationTypeId == OrganisationTypeEnum.Customer) {
      this.router.navigate([`app/customer-information/${org.id}`]);
    }
  }

  openOrgSelector() {
    this.eventService.OrganisationSelectorEvent.emit({
      eventType: OrganisationSelectorEventTypeEnum.OpenSelector,
      args: { emitSelectEvent: true },
    });
  }

  ngOnDestroy() {
    if (this.transactionSearchSubscription) this.transactionSearchSubscription.unsubscribe();
  }
}
